export class Slider {
  constructor(sliderID = 'slider') {
    this.sliderID = sliderID;
    this.$slides = $(`#${this.sliderID}__container .${this.sliderID}__item`);
    this.$navLeft = $(`#${this.sliderID}__navigation--left`);
    this.$navRight = $(`#${this.sliderID}__navigation--right`);
    this.$navBottom = $(`#${this.sliderID}__navigation--bottom`);
    this.slideCount = this.$slides.length;
    this.currentPosition = 0;
  }

  init() {

    // eslint-disable-next-line consistent-this
    const instance = this;
    this.$navLeft.click(function() {
      instance.previous(instance);
    });
    this.$navRight.click(function() {
      instance.next(instance);
    });

    let i;
    for (i = 0; i < this.slideCount; i++) {

      // hide all slides but the first
      if (i !== 0) {
        $(this.$slides.get(i)).hide();
      }

      // add a dot for each image
      const dotId = `${this.sliderID}__navigation--bottom__dot__${i}`;
      this.$navBottom.append(`<div class='slider__navigation--bottom__dot icon icon-dot' id='${dotId}' data-pos='${i}'></div>`);
      
      // set up event listener for dot
      $(`#${dotId}`).click(function() {
        instance.go($(this).data('pos'));
      });

      this.go(0);
    }
  }

  go(position) {
    let i;
    this.currentPosition = position;
    for (i = 0; i < this.slideCount; i++) {

      // hide all slides but the first
      if (i !== position) {
        $(this.$slides.get(i)).hide();
        $(`#${this.sliderID}__navigation--bottom__dot__${i}`).removeClass('icon-dot--green');
        $(`#${this.sliderID}__navigation--bottom__dot__${i}`).addClass('icon-dot');
      } else {
        $(this.$slides.get(i)).show();
        $(`#${this.sliderID}__navigation--bottom__dot__${i}`).addClass('icon-dot--green');
        $(`#${this.sliderID}__navigation--bottom__dot__${i}`).removeClass('icon-dot');
      }

      if (position === 0) {
        this.$navLeft.addClass('opacity-50')
      } else {
        this.$navLeft.removeClass('opacity-50')
      }
      if (position === this.slideCount - 1) {
        this.$navRight.addClass('opacity-50')
      } else {
        this.$navRight.removeClass('opacity-50')
      }
    }
  }

  next(instance) {
    if (instance.currentPosition < instance.slideCount - 1) {
      instance.go(++instance.currentPosition);
    }
  }

  previous(instance) {
    if (instance.currentPosition > 0) {
      instance.go(--instance.currentPosition);
    }
  }



}
